import { useState } from "react";

interface SliderProps {
    onToggle?: (value: boolean) => void;
    className?: string;
    isToggled?: boolean;
}

export default function Slider({ onToggle, isToggled, className = "" }: SliderProps) {
    const [enabled, setEnabled] = useState(isToggled);

    const handleToggle = () => {
        const newValue = !enabled;
        setEnabled(newValue);
        if (onToggle) onToggle(newValue);
    };

    return (
        <button
            type="button"
            onClick={handleToggle}
            className={`relative inline-flex items-center w-11 h-6 rounded-full transition-colors duration-300 ${enabled ? "bg-indigo-400" : "bg-gray-200"
                } ${className}`}
        >
            <span
                className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 ${enabled ? "translate-x-5" : ""
                    }`}
            ></span>
        </button>
    );
}
